import { Routes, Route } from "react-router-dom";

// import { UserContext } from "../Components/Context/UserContext";
import { useEffect, useContext, useState } from 'react';
import Inventory from "../Pages/Frontend/Inventory";
import InventoryDetail from "../Pages/Frontend/InventoryDetail";

const AppRoutes = () => {
    // const { user, loggedInCheck } = useContext(UserContext);

    // const [checkedLogin, setCheckedLogin] = useState(null);

    // useEffect(() => {
	// 	if (!checkedLogin) {
	// 		checkLogin();
	// 	}
	// }, []);

	// const checkLogin = async () => {
	// 	console.log('checking login');
	// 	await loggedInCheck();
	// 	setCheckedLogin(true);
	// 	console.log(user);
	// };

    return (
        <Routes>
			<Route exact path='/inventory/' Component={Inventory} />
			<Route path="/inventory/vdp" element={<InventoryDetail />} />
        </Routes>
    );
};

export default AppRoutes;
